import { render, staticRenderFns } from "./rilibaoindex.vue?vue&type=template&id=2cb9c7b4&scoped=true&"
import script from "./rilibaoindex.vue?vue&type=script&lang=js&"
export * from "./rilibaoindex.vue?vue&type=script&lang=js&"
import style0 from "./rilibaoindex.vue?vue&type=style&index=0&id=2cb9c7b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9c7b4",
  null
  
)

export default component.exports